import {Component, Input, OnInit} from '@angular/core';
import {DashboardService} from '@services/dashboard.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataBuilderModalService} from '@services/data-builder-modal.service';
import {RequestService} from '@services/request.service';

@Component({
    selector: 'app-autoload-punti-vendita',
    templateUrl: './autoload-punti-vendita.component.html',
    styleUrls: ['./autoload-punti-vendita.component.css']
})
export class AutoloadPuntiVenditaComponent implements OnInit {
    _urlPuntiVendita: string;
    autoloadTableUrl: string;
    data = {
        giorno_paragone: '$giornoParagone',
        mese: '',
        prevMonth: 0,
        pdv_totali: 0,
        pdv_totali_perc: 0,
        produttivi: 0,
        improduttivi: 0,
        produttivi_perc: 0,
        improduttivi_perc: 0,
        produttivi_persi_prev: 0,
        produttivi_persi_paragone: 0,
        paragone: '',
        urls: {
            pdvTotali: null,
            pdvProduttivi: null,
            pdvImproduttivi: null,
            pdvMenoProduttiviParagone: null,
            pdvMenoProduttiviMese: null,
        }
    };
    status = 'hidden';

    @Input() brand: string

    @Input() set urlPuntiVendita(value: string) {
        this._urlPuntiVendita = value;

        if (this._urlPuntiVendita !== undefined) {
            this.loadPuntiVendita();
        }
    }

    constructor(
        private requestService: RequestService,
        public dbm: DataBuilderModalService
    ) {
    }

    ngOnInit() {

    }

    private loadPuntiVendita() {
        this.status = 'loading';
        this.requestService.get(this.brand + this._urlPuntiVendita)
            .subscribe((data) => {
                this.data = data.result;
                this.status = 'hidden';
            }, (error) => {
                this.status = 'error';
            });
    }
}
